export default {
    newHome: {
        eyebrow: '網上及個人化平安紙訂立服務',
        heroTitle: '為{{location}}及全球資產訂立您的平安紙',
        heroBody: '您可自行網上訂立平安紙，或由遺產規劃專員一對一協助。NobleWills 支援{{location}}及海外的個人、夫婦及家庭，包括在多個國家持有資產的人士。',
        primaryCta: '尋找合適的平安紙服務',
        heroPrimaryCta: '比較平安紙服務',
        secondaryCta: '了解流程',
        talkToExpert: '與專員聯絡',
        trustHuman: '真人審閱',
        trustSecure: '加密及私隱保障',
        trustCrossBorder: '跨境支援',
        chooserEyebrow: '兩種訂立平安紙方式',
        chooserTitle: '選擇適合您的平安紙訂立方式',
        chooserBody: '兩項服務均提供清晰指引及真人支援。您可按自己的情況及偏好的服務方式作出選擇。',
        onlineLabel: '自行完成，真人審閱',
        onlineTitle: '網上平安紙服務',
        onlineBody: '適合意願較直接，並希望按自己的步伐於網上回答指引問題的人士。',
        onlineBenefit1: '按自己的步伐完成指引問題',
        onlineBenefit2: '文件完成前由真人審閱',
        onlineBenefit3: '儲存進度，並可在需要時獲得支援',
        onlineCta: '了解網上平安紙',
        premiumLabel: '一對一個人化指引',
        premiumTitle: '綜合平安紙服務',
        premiumBody: '適合複雜、敏感或國際性的情況，或希望由團隊親自協助規劃平安紙的人士。',
        premiumBenefit1: '私人的遺產規劃諮詢',
        premiumBenefit2: '個人化規劃及度身訂製草擬',
        premiumBenefit3: '由完成規劃至定稿的一對一指引',
        premiumCta: '了解綜合平安紙',
        individualPriceLabel: '個人平安紙',
        couplePriceLabel: '夫婦平安紙',
        coupleSavings: '節省{{savings}}',
        onlinePricingNote: '價格按每個司法管轄區計算。',
        premiumPricingNote: '所示價格適用於您的第一份平安紙；額外國家的平安紙會分開收費。',
        stakesEyebrow: '為甚麼訂立平安紙很重要',
        stakesTitle: '重要決定不應留下不確定性。',
        stakesBody: '平安紙可記錄誰應管理您的遺產、誰應獲得您的資產，以及您希望誰照顧子女。NobleWills 協助您清楚處理這些選擇，避免法律術語及不必要的壓力。',
        guideEyebrow: '值得信賴的周全指引',
        guideTitle: '遺產規劃專業知識，配合安全科技支援',
        guideCredentialTitle: '由法律及科技專才建立',
        guideCredentialBody: '由合資格律師及軟件工程師共同創立，結合遺產規劃經驗及實用的產品工程。',
        guideReviewTitle: '真人指引及審閱',
        guideReviewBody: '每份網上平安紙均會接受真人內容一致性檢查。綜合客戶則可在規劃、草擬及定稿過程中獲一對一支援。',
        guideSecurityTitle: '私隱及加密保障',
        guideSecurityBody: '您的個人資料在傳輸中、欄位層級及儲存時均受加密保護。',
        guidePartnersTitle: '策略夥伴',
        reviewStats: 'Google 評論 {{count}} 則，評分 {{rating}}/5',
        reviewFallback: '閱讀我們的 Google 客戶評論',
        reviewStarsLabel: '5 分滿分',
        guideLegalFounderAlt: 'NobleWills 合資格律師及聯合創辦人',
        guideLegalFounderName: '葉媛瓊',
        guideLegalFounderRole: '合資格律師',
        guideLegalFounderTitle: '行政總裁及聯合創辦人',
        guideTechFounderAlt: 'NobleWills 軟件工程師及聯合創辦人',
        guideTechFounderName: '麥智仁',
        guideTechFounderRole: '軟件工程師',
        guideTechFounderTitle: '技術總監及聯合創辦人',
        processEyebrow: '簡單清晰的流程',
        processTitle: '三個清晰步驟完成您的平安紙',
        step1Title: '尋找合適服務',
        step1Body: '了解網上及綜合平安紙服務，然後按您希望如何規劃平安紙，選擇最適合的服務。',
        step2Title: '告訴我們重要的事',
        step2Body: '分享您的家人、資產、意願，以及所涉及國家的資料。',
        step3Title: '審閱並完成您的平安紙',
        step3Body: '收到文件後，仔細審閱，並按照我們的簽署指引完成程序。',
        processOutcome: '每一步都有清晰方向；過程中如有需要，亦可獲得指引。',
        successEyebrow: '為下一步帶來清晰方向',
        successTitle: '讓家人明白的遺產規劃',
        successBody: '記錄您的意願，安排負責執行的人士，並為您關心的人訂下清晰指示。',
        success1: '委任遺囑執行人及監護人',
        success2: '照顧伴侶、家人、寵物及慈善機構',
        success3: '記錄遺贈及整理資產',
        success4: '規劃多國資產',
        crossBorderEyebrow: '跨境平安紙',
        crossBorderTitle: '處理多個司法管轄區資產的平安紙',
        crossBorderBody: '了解 NobleWills 可透過網上及綜合平安紙服務提供協助的地區。',
        crossBorderCta: '查詢跨境平安紙',
        jurisdictionMapLabel: 'NobleWills 支援的司法管轄區地圖',
        jurisdictionOnlineLegend: '網上及綜合服務',
        jurisdictionPremiumLegend: '只限綜合服務',
        jurisdictionOnlineDescription: '可透過網上及綜合平安紙服務辦理',
        jurisdictionPremiumDescription: '只可透過綜合平安紙服務辦理',
        jurisdictionOnlineCta: '查看網上服務國家',
        jurisdictionPremiumCta: '查看綜合服務國家',
        relatedEyebrow: '更多提前規劃方式',
        relatedTitle: '相關遺產規劃服務',
        relatedBody: '平安紙通常是起點。當您需要時，可探索您所在地可提供的其他服務。',
        relatedPowerTitle: '持久授權書',
        relatedPowerBody: '在您失去精神行為能力時，委任您信任的人處理財務事宜。',
        relatedGuardianshipTitle: '臨時監護',
        relatedGuardianshipBody: '記錄在緊急或短暫情況下，誰應照顧您的子女。',
        relatedSessionTitle: '遺產規劃諮詢',
        relatedSessionBody: '與平安紙專員討論遺囑執行人、監護人、海外資產及實際下一步。',
        relatedStorageTitle: '保管平安紙服務',
        relatedStorageBody: '安全儲存正本文件，讓您及遺囑執行人更容易取回。',
        relatedCta: '了解更多',
        faqEyebrow: '平安紙常見問題',
        faqTitle: '大家通常想知道的事',
        faq1Question: '我應選擇網上還是綜合平安紙服務？',
        faq1Answer: '網上服務適合意願較直接，並願意按自己步伐完成指引問題的人士。綜合服務則較適合複雜或敏感情況，或希望進行私人諮詢及獲得更多個人化指引的人士。',
        faq2Question: '我可以網上訂立平安紙嗎？',
        faq2Answer: '可以。網上平安紙服務讓您回答問題、儲存進度，並在文件定稿前獲得真人支援及內容一致性檢查。',
        faq3Question: 'NobleWills 可協助處理多個國家的資產嗎？',
        faq3Answer: 'NobleWills 支援多個司法管轄區的遺產規劃。部分地區可直接透過平台辦理，其他地區可由團隊協助安排。每個司法管轄區均會分開處理及收費。',
        faq4Question: '專員會檢查我的平安紙嗎？',
        faq4Answer: '會。我們會為網上平安紙提交內容進行一致性檢查；綜合客戶則在指引、草擬及定稿過程中獲遺產規劃專員親自協助。',
        faq5Question: '簽署及見證程序如何進行？',
        faq5AnswerInPersonWitnessing:
            '綜合平安紙，以及提供並選擇見證服務的網上平安紙，我們會與您面對面簽署及見證。否則，完成的文件會附有簽署及見證指引。要求視乎司法管轄區而定，請仔細遵從每份平安紙附上的指引。',
        faq5Answer: '完成的文件會附有簽署及見證指引。要求視乎司法管轄區而定，請仔細遵從每份平安紙附上的指引。',
        faq6Question: '日後可以更新我的平安紙嗎？',
        faq6Answer: '可以。網上及綜合服務均提供日後更新的編輯會籍。您可在選擇前查看會籍詳情及價格。',
        finalEyebrow: '由適合您的服務開始',
        finalTitle: '選擇切合您需要的平安紙訂立服務。',
        finalBody: '按自己的步伐網上訂立平安紙，或由綜合團隊提供更個人化的指引。',
        mobileCta: '選擇我的平安紙服務',
        imageAlt: '一家人在家中一起審閱遺產規劃文件',
    },
};
